import { useEffect, useState } from "react";
import { Package } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useGarage } from "@/context/GarageContext";
import { api } from "@/lib/api";
import { t } from "@/i18n";

let cache = null;
let cacheGid = null;

export function PartPicker({ i, partId, onPick }) {
  const { hasFeature, activeId } = useGarage();
  const enabled = hasFeature("inventory");
  const [parts, setParts] = useState(cacheGid === activeId && cache ? cache : []);
  useEffect(() => {
    if (!enabled || (cache && cacheGid === activeId)) return;
    api.get("/inventory/parts").then(({ data }) => { cache = data; cacheGid = activeId; setParts(data); }).catch(() => {});
  }, [enabled, activeId]);
  if (!enabled) return null;
  return (
    <div className="col-span-12 -mt-1 flex items-center gap-2 text-xs text-slate-500">
      <Package className="h-3.5 w-3.5" />
      <Select value={partId || "none"} onValueChange={(v) => onPick(v === "none" ? null : parts.find((p) => p.id === v))}>
        <SelectTrigger className="h-8 max-w-sm text-xs" data-testid={`line-${i}-part-picker`}><SelectValue placeholder={t("b8.inv.pick")} /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none">{t("b8.inv.freeText")}</SelectItem>
          {parts.map((p) => <SelectItem key={p.id} value={p.id}>{p.sku} — {p.name} ({p.qty_on_hand} {t("b8.inv.onHand")})</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}

export const resetPartCache = () => { cache = null; };
